/**
 * This file is responsible for blade interaction handler (Theme UI)
 * this not related to reactjs admin, any reactjs admin should be
 * placed under /Lib directory.
 */

/**
 * Initialize main theme UI animation and interaction
 */
export function initializeThemeUI() {
  $('.mobile-menu')
    .off('click.themeUI')
    .on('click.themeUI', function () {
      $('#mobile-drawer').toggle();
    });

  $('#toc')
    .off('click.themeUI')
    .on('click.themeUI', function () {
      $('#toc-modal').toggle();
    });

  $('#privacy')
    .off('click.themeUI')
    .on('click.themeUI', function () {
      $('#privacy-modal').toggle();
    });

  $('#btn-back-to-top')
    .off('click.themeUI')
    .on('click.themeUI', function () {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    });

  $('.close-modal')
    .off('click.themeUI')
    .on('click.themeUI', function () {
      const $modal = $(this).closest('div[id$="-modal"]');
      const modalId = $modal.attr('id');

      if (modalId.startsWith('promo-') && modalId.endsWith('-modal')) {
        $modal.remove();
      } else {
        $modal.hide();
      }
    });
}

/**
 * Responsible for popup UI initialization
 * @param {String} loaderUrl 
 */
export function initializeIbeWidget(loaderUrl = '') {
  $('.popup_action').off('click.ibe').on('click.ibe', function () {
    const widget = $('#ibe-widget');
    const container = document.getElementById('ibe-iframe-container');
    const loading = document.getElementById('ibe-loading');

    if (!widget.length || !container || !loading) return;

    loading.style.display = 'flex';

    widget
      .addClass('slide-up visible')
      .removeClass('hidden');

    const oldIframe = document.getElementById('ibe_loader');
    if (oldIframe) oldIframe.remove();

    const iframe = document.createElement('iframe');
    iframe.id = 'ibe_loader';
    iframe.className = 'absolute inset-0 w-full h-full border-0';

    iframe.onload = function () {
      loading.style.display = 'none';
    };

    iframe.src = loaderUrl;
    container.appendChild(iframe);
  });

  $('#ibe_close').off('click.ibe').on('click.ibe', function () {
    const widget = $('#ibe-widget');

    widget
      .removeClass('slide-up')
      .addClass('close-down');

    setTimeout(() => {
      widget.addClass('hidden');
      widget.removeClass('close-down');
    }, 400);
  });
}

/**
 * Extend tinyMCE table styling for theme UI
 * Wrap the description tinymce table once it's available
 * 
 * @param {Number} retryCount 
 */
  export function wrapTable(retryCount = 0) {
    const table = document.querySelector('.description table')
    if (table) {
      const wrapper = document.createElement('div')
      wrapper.classList.add('table-wrapper')
      table.parentNode.insertBefore(wrapper, table)
      wrapper.appendChild(table)
    } else if (retryCount < 5) {
      setTimeout(() => wrapTable(retryCount + 1), 100) // retry
    } else {
      // No table found, do nothing
      // console.warn('No table found')
    }
  }

  /**
   * Handle booking form checkin/checkout date picker
   * 
   * @param {String} minDate 
   * @param {Number} minNight 
   * @returns 
   */
  export function initializeBookingForm(minDate, minNight) {
    const checkInInput = document.getElementById('check-in-input');
    const checkOutInput = document.getElementById('check-out-input');

    if (!checkInInput || !checkOutInput) return;

    function formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    function addDays(dateString, days) {
      const [year, month, day] = dateString.split('-').map(Number);
      const date = new Date(year, month - 1, day);
      date.setDate(date.getDate() + days);
      return formatDate(date);
    }

    function getDefaultCheckIn() {
      return minDate === 'today' ?
        formatDate(new Date()) :
        minDate;
    }

    function syncCheckout() {
      const checkoutDate = addDays(checkInInput.value, minNight);
      checkOutInput.min = checkoutDate;
      checkOutInput.value = checkoutDate;
    }

    const defaultCheckIn = getDefaultCheckIn();

    checkInInput.min = defaultCheckIn;

    if (!checkInInput.value) {
      checkInInput.value = defaultCheckIn;
    }

    syncCheckout();

    // Avoid duplicate listener
    checkInInput.removeEventListener('change', syncCheckout);
    checkInInput.removeEventListener('input', syncCheckout);

    checkInInput.addEventListener('change', syncCheckout);
    checkInInput.addEventListener('input', syncCheckout)
  }


  /**
   * Convert date format into desired format
   * @param {String} dateStr 
   * @param {Boolean} isTriplaFormat 
   * @returns 
   */
  export function convertDate(dateStr, isTriplaFormat) {
    const [year, month, day] = dateStr.split('-');
    if (isTriplaFormat) {
      return `${year}/${month}/${day}`;
    }
    return `${day}-${month}-${year}`;
  }


  /**
   * Validate given date into certain format
   * @param {*} checkInInput 
   * @param {*} checkOutInput 
   * @param {String} messages 
   * @returns 
   */
  export function validateDate(
    checkInInput,
    checkOutInput,
    messages = {}
  ) {
    if (!checkInInput || !checkOutInput) return true;

    const checkInDate = new Date(checkInInput.value + 'T00:00:00');
    const checkOutDate = new Date(checkOutInput.value + 'T00:00:00');

    const defaults = {
      empty: 'Please select both check-in and check-out dates.',
      invalidCheckIn: 'Check-in date cannot be after check-out date.',
      invalidCheckOut: 'Check-out date cannot be before check-in date.',
    };

    const text = { ...defaults, ...messages };

    function showError(selector, message) {
      $(selector)
        .removeClass('border-transparent')
        .addClass('border-red-500');

      $('#form-error').removeClass('hidden');

      $('#error-text')
        .addClass('text-red-500')
        .text(message);
    }

    if (!checkInInput.value || !checkOutInput.value) {
      showError('#check-in-input', text.empty);
      return false;
    }

    if (checkInDate > checkOutDate) {
      showError('#check-out-input', text.invalidCheckOut);
      return false;
    }

    return true;
  }

  /**
   * Responsible for main booking form initialization
   * 
   * @param {Boolean} isTriplaUrl 
   * @param {Boolean} hasWidgetIframe 
   * @returns 
   */
  export function initializeMainBookingForm({isTriplaUrl = false, hasWidgetIframe = false} = {}) {
    const form = document.getElementById('main-booking-form');
    if (!form) return;

    const originalAction = form.getAttribute('action');
    const originalUrl = new URL(originalAction, window.location.origin);
    const preservedParams = new URLSearchParams(originalUrl.search);

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const actionUrl = new URL(
        originalUrl.pathname,
        originalUrl.origin
      );
      
      preservedParams.forEach((value, key) => {
        actionUrl.searchParams.set(key, value);
      });

      const formData = new FormData(form);

      const checkInInput = document.getElementById('check-in-input');
      const checkOutInput = document.getElementById('check-out-input');

      if (checkInInput?.value) {
        formData.set(
          checkInInput.name,
          window.Main.convertDate(checkInInput.value, isTriplaUrl)
        );
      }

      if (checkOutInput?.value) {
        formData.set(
          checkOutInput.name,
          window.Main.convertDate(checkOutInput.value, isTriplaUrl)
        );
      }

      formData.forEach((value, key) => {
        actionUrl.searchParams.set(key, value);
      });

      const finalUrl = actionUrl.toString();

      if (!hasWidgetIframe) {
        window.location.assign(finalUrl);
      } else {
        const iframe = document.getElementById('ibe_loader');
        if (iframe) iframe.src = finalUrl;
      }
    })
  }

  /**
   * Responsible for main contact form
   */
  export function initializeContactForm({isStatic = false, messages = {}} = {}) {
    const defaults = {
      loading: 'Please wait...',
      send: 'Send',
    };

    const text = { ...defaults, ...messages };

    $('#contact-form')
      .off('submit.contact')
      .on('submit.contact', function (event) {
        event.preventDefault();

        const form = this;
        const $form = $(form);

        const csrfToken = document
          .querySelector('meta[name="csrf-token"]')
          ?.getAttribute('content');

        const formAction = $form.data('action');
        const formData = new FormData(form);
        const locale = window.location.pathname.split('/')[1];

        const headers = {
          Accept: 'application/json',
          'X-Locale': locale,
        };

        if (!isStatic) {
          headers['X-CSRF-TOKEN'] = csrfToken;
        }

        $.ajax({
          url: formAction,
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          dataType: 'json',
          headers,

          beforeSend() {
            $('#contact-feedback-message')
              .removeClass('flex')
              .addClass('hidden');

            $('[id$="-error"]')
              .addClass('hidden')
              .text('');

            $form
              .find('.border-red-500')
              .removeClass('border-red-500')
              .addClass('border-transparent');

            $('#contact-send-btn')
              .text(text.loading)
              .prop('disabled', true);
          },

          success(data) {
            $('#contact-send-btn')
              .text(text.send)
              .prop('disabled', false);

            if (data.success) {
              $('#contact-feedback-message')
                .removeClass('hidden text-red-500')
                .addClass(
                  'text-green-500 border-green-500 fade-in flex'
                );

              $('#message-text')
                .removeClass('text-red-500')
                .addClass('text-green-500')
                .text(data.success);

              form.reset();
            } else {
              $('#contact-feedback-message')
                .removeClass('hidden text-green-500')
                .addClass(
                  'text-red-500 border-red-500 fade-in flex'
                );

              $('#message-text')
                .addClass('text-red-500')
                .text(data.error);
            }

            if (
              typeof grecaptcha !== 'undefined' &&
              grecaptcha.reset
            ) {
              grecaptcha.reset();
            }
          },

          error(xhr) {
            const response = xhr.responseJSON || {};
            const errors = response.errors || {};
            const generalError =
              xhr.status >= 500
                ? 'Something went wrong. Please try again later.'
                : response.error ||
                  response.message ||
                  xhr.responseText ||
                  'Something went wrong. Please try again.';

            $('#contact-send-btn')
              .text(text.send)
              .prop('disabled', false);

            // Handle validation errors (422)
            if (Object.keys(errors).length) {
              Object.keys(errors).forEach((key) => {
                const message = errors[key][0];
                let input;

                if (key.startsWith('custom.')) {
                  const field = key.replace('custom.', '');
                  input = $(`[name="custom[${field}]"]`);

                  $(`#custom-${field}-error`)
                    .removeClass('hidden')
                    .text(message);
                } else {
                  input = $(`[name="${key}"]`);

                  $(`#${key}-error`)
                    .removeClass('hidden')
                    .text(message);
                }

                if (input.length) {
                  input
                    .addClass('border-red-500 text-red-500')
                    .removeClass('border-transparent');
                }
              });
            } else {
              // Handle general server error (500, timeout, cURL)
              $('#contact-feedback-message')
                .removeClass('hidden text-green-500')
                .addClass('text-red-500 border-red-500 fade-in flex');

              $('#message-text')
                .removeClass('text-green-500')
                .addClass('text-red-500')
                .text(generalError);
            }

            if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) {
              grecaptcha.reset();
            }
          }
        });
      });
  }

 export function initializeRoomBookingForm({isTriplaUrl = false, messages = {},} = {}) {
  $('#room-book-form').off('submit.booking').on('submit.booking', function (e) {
    e.preventDefault();

    const form = document.getElementById('room-book-form');
    const formData = new FormData(form);

    const checkInInput = document.getElementById('check-in-input');
    const checkOutInput = document.getElementById('check-out-input');

    const isValid = window.Main.validateDate(
      checkInInput,
      checkOutInput,
      messages
    );

    if (!isValid) return;

    if (checkInInput?.value) {
      formData.set(
        checkInInput.name,
        window.Main.convertDate(
          checkInInput.value,
          isTriplaUrl
        )
      );
    }

    if (checkOutInput?.value) {
      formData.set(
        checkOutInput.name,
        window.Main.convertDate(
          checkOutInput.value,
          isTriplaUrl
        )
      );
    }

    const actionUrl = new URL(this.action);

    formData.forEach((v, k) => {
      actionUrl.searchParams.set(k, v);
    });

    const finalUrl = actionUrl.toString();

    const widget = document.getElementById('ibe-widget');
    const container = document.getElementById('ibe-iframe-container');
    const loading = document.getElementById('ibe-loading');

    if (!widget || !container || !loading) {
      window.open(finalUrl);
      return;
    }

    loading.style.display = 'flex';

    widget.classList.add('slide-up', 'visible');
    widget.classList.remove('hidden');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const oldIframe = document.getElementById('ibe_loader');

        if (oldIframe) oldIframe.remove();

        const iframe = document.createElement('iframe');

        iframe.id = 'ibe_loader';
        iframe.className = 'absolute inset-0 w-full h-full border-0';

        iframe.onload = function () {
          setTimeout(() => {
            loading.style.display = 'none';
          }, 1800);
        };

        iframe.src = finalUrl;
        container.appendChild(iframe);
      });
    });
  });
}

  window.Main = {
    initializeThemeUI,
    wrapTable,
    initializeBookingForm,
    convertDate,
    validateDate,
    initializeIbeWidget,
    initializeBookingForm,
    initializeContactForm,
    initializeRoomBookingForm,
    initializeMainBookingForm,
  };

